import { observer } from "mobx-react-lite";
import { Fragment, useRef, useState } from "react";
import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  InputNumber,
  FormProps,
  Row,
  Col,
  ConfigProvider,
  TreeSelect,
  Table,
  Upload,
  UploadProps,
  GetProp,
  message,
  UploadFile,
  Image,
  FormInstance,
} from "antd";
import {
  templateParamUploadImgStore,
  CommonStore,
  TemplateManageStore,
  socialCreditCertificateObjectNamesUploadImgStore,
  orderVoucherObjectNamesUploadImgStore,
  signAuthzCertificateObjectNamesUploadImgStore,
} from "../../../store";
import "./index.css";
import "dayjs/locale/zh-cn";
import {
  CloseOutlined,
  PlusOutlined,
  VerticalAlignBottomOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { UploadChangeParam } from "antd/lib/upload/interface";
import UploadImgStore from "../../../store/modules/call_card/uploadImg_store";

function Add() {
  const form = Form.useFormInstance();
  const ref = useRef<FormInstance<any>>();

  const { Option } = Select;

  const getFormData = (changeValue: any, allValues: any) => {
    console.log(changeValue, allValues);
    if (changeValue.templateSignatureNo) {
      TemplateManageStore.templateGetOne(changeValue.templateSignatureNo);
    }
    if (changeValue.templateSignature) {
      ref.current?.setFieldValue("socialCreditCertificateObjectNames", null);
      ref.current?.setFieldValue("orderVoucherObjectNames", null);
      ref.current?.setFieldValue("signAuthzCertificateObjectNames", null);
      ref.current?.setFieldValue("templateSignatureNo", null);
      TemplateManageStore.clearImageObj();
    }
    changeValue.no = TemplateManageStore.addOrUpdateForm.no;
    changeValue.templateStatus =
      TemplateManageStore.addOrUpdateForm.templateStatus;
    changeValue.templateSignature = changeValue.templateSignature
      ? changeValue.templateSignature
      : TemplateManageStore.addOrUpdateForm.templateSignature;
    TemplateManageStore.setAddOrUpdateForm({ ...changeValue, ...allValues });
    console.log(
      JSON.parse(JSON.stringify(TemplateManageStore.addOrUpdateForm))
    );
  };
  const submitData: FormProps<any>["onFinish"] = async (values) => {
    console.log(
      JSON.parse(JSON.stringify(TemplateManageStore.addOrUpdateForm))
    );
    if (TemplateManageStore.addOrUpdateModal.add) {
      TemplateManageStore.templateAdd();
    } else {
      TemplateManageStore.templateUpdate();
    }
    templateParamUploadImgStore.reset();
    socialCreditCertificateObjectNamesUploadImgStore.reset();
    orderVoucherObjectNamesUploadImgStore.reset();
    signAuthzCertificateObjectNamesUploadImgStore.reset();
  };
  const onFinishFailed: FormProps<any>["onFinishFailed"] = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getBase64 = (file: FileType): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  //营业执照图片
  type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );
  //营业执照图片
  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }
    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleUploadFileChange = async (
    { file, fileList: newFileList }: UploadChangeParam,
    store: UploadImgStore,
    type: string
  ) => {
    console.log(file, newFileList);

    if (newFileList && newFileList.length > 0 && file.type) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("请上传图片格式文件!");
      } else if (!((file as any).size / 1024 / 1024 < 2)) {
        message.error("图片必须小于2MB!");
      } else {
        // store.setFileList(newFileList, file);
        if (
          templateParamUploadImgStore.fileList.length +
            socialCreditCertificateObjectNamesUploadImgStore.fileList.length +
            orderVoucherObjectNamesUploadImgStore.fileList.length +
            signAuthzCertificateObjectNamesUploadImgStore.fileList.length >
            4 &&
          file.status !== "removed"
        ) {
          message.error("最多上传5张图片，已到达上限");
        } else {
          await TemplateManageStore.temporaryUpload(
            type,
            file,
            newFileList,
            store
          );
        }
      }
    } else {
      console.log(newFileList, file);

      store.setFileList(newFileList);
    }
  };

  function beforeUpload(file: any) {
    return false;
  }

  const closeModal = () => {
    templateParamUploadImgStore.reset();
    socialCreditCertificateObjectNamesUploadImgStore.reset();
    orderVoucherObjectNamesUploadImgStore.reset();
    signAuthzCertificateObjectNamesUploadImgStore.reset();
    TemplateManageStore.addOrUpdateModal.close();
  };

  const controlTemplateSignature = () => {
    TemplateManageStore.isTemplateSignature();
    ref.current?.setFieldValue("templateSignature", null);
  };

  return (
    <Fragment>
      <Modal
        width={"600px"}
        centered
        title={
          TemplateManageStore.addOrUpdateModal.add ? "新增模版" : "模版编辑"
        }
        open={TemplateManageStore.addOrUpdateModal.isOpen}
        destroyOnClose={true}
        loading={TemplateManageStore.modalLoading}
        onCancel={() => closeModal()}
        footer={null}
      >
        <Form
          ref={ref as any}
          form={form}
          style={{ paddingTop: "10px" }}
          labelCol={{ flex: "140px" }}
          labelWrap
          initialValues={TemplateManageStore.addOrUpdateForm}
          onFinish={submitData}
          onFinishFailed={onFinishFailed}
          onValuesChange={getFormData}
        >
          <Row
            justify="start"
            style={{ maxHeight: "calc(60vh)", overflow: "auto" }}
          >
            <Col span={23}>
              <Form.Item
                label="被叫运营商"
                name="calledOperator"
                rules={[{ required: true, message: "请选择被叫运营商" }]}
              >
                <Select
                  placeholder="请选择被叫运营商"
                  allowClear
                  disabled={
                    TemplateManageStore.addOrUpdateForm.templateStatus === 2 ||
                    TemplateManageStore.addOrUpdateForm.templateStatus === 4
                      ? true
                      : false
                  }
                >
                  <Option value={"CT"}>电信</Option>
                  <Option value={"ALL"}>全部运营商</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={23}>
              <Form.Item
                label="模版内容"
                name="templateInfo"
                rules={[{ required: true, message: "请输入模版内容" }]}
              >
                <Input.TextArea
                  placeholder="请输入模版内容"
                  maxLength={67}
                  showCount
                  disabled={
                    TemplateManageStore.addOrUpdateForm.templateStatus === 2 ||
                    TemplateManageStore.addOrUpdateForm.templateStatus === 4
                      ? true
                      : false
                  }
                />
              </Form.Item>
            </Col>
            <Col span={23}>
              <Form.Item
                label="是否有变量"
                name="isTemplateParamInfo"
                rules={[{ required: true, message: "请选择是否有变量" }]}
              >
                <Select
                  placeholder="请选择是否有变量"
                  allowClear
                  disabled={
                    TemplateManageStore.addOrUpdateForm.templateStatus === 2 ||
                    TemplateManageStore.addOrUpdateForm.templateStatus === 4
                      ? true
                      : false
                  }
                >
                  <Option value={true}>是</Option>
                  <Option value={false}>否</Option>
                </Select>
              </Form.Item>
            </Col>
            {TemplateManageStore.addOrUpdateForm.isTemplateParamInfo && (
              <Col span={23}>
                <Form.Item
                  label="变量说明"
                  name="templateParamInfo"
                  rules={[{ required: true, message: "至少一个变量说明" }]}
                >
                  {/* <Form.List name="templateParamInfo">
                    {(subFields, subOpt) => (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: 16,
                        }}
                      >
                        {subFields.map((subField) => (
                          <Space key={subField.key}>
                            <Form.Item
                              noStyle
                              name={[subField.name, "templateParam"]}
                            >
                              <Input placeholder="变量名：p0" 
                              disabled={
                                (TemplateManageStore.addOrUpdateForm.templateStatus === 2 ||
                                TemplateManageStore.addOrUpdateForm.templateStatus === 4)
                                  ? true
                                  : false
                              }/>
                            </Form.Item>
                            <Form.Item
                              noStyle
                              name={[subField.name, "templateParamExplain"]}
                            >
                              <Input placeholder="变量说明：姓名" 
                              disabled={
                                (TemplateManageStore.addOrUpdateForm.templateStatus === 2 ||
                                TemplateManageStore.addOrUpdateForm.templateStatus === 4)
                                  ? true
                                  : false
                              }/>
                            </Form.Item>
                            {TemplateManageStore.addOrUpdateForm.templateStatus !== 2 &&
                              TemplateManageStore.addOrUpdateForm.templateStatus !== 4 && <CloseOutlined
                              onClick={() => {
                                subOpt.remove(subField.name);
                              }}
                            />}
                          </Space>
                        ))}
                        {TemplateManageStore.addOrUpdateForm.templateStatus !== 2 &&
                              TemplateManageStore.addOrUpdateForm.templateStatus !== 4 && <Button
                          type="dashed"
                          onClick={() => subOpt.add()}
                          block
                        >
                          + 添加变量说明
                        </Button>}
                      </div>
                    )}
                  </Form.List> */}
                  <Form.List name="templateParamInfo">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Space
                            key={key}
                            style={{ display: "flex", marginBottom: 8 }}
                            align="baseline"
                          >
                            <Form.Item
                              {...restField}
                              name={[name, "templateParam"]}
                              rules={[
                                { required: true, message: "请填写变量名" },
                              ]}
                            >
                              <Input
                                placeholder="变量名：p0"
                                disabled={
                                  TemplateManageStore.addOrUpdateForm
                                    .templateStatus === 2 ||
                                  TemplateManageStore.addOrUpdateForm
                                    .templateStatus === 4
                                    ? true
                                    : false
                                }
                              />
                            </Form.Item>
                            <Form.Item
                              {...restField}
                              name={[name, "templateParamExplain"]}
                              rules={[
                                { required: true, message: "请填写变量说明" },
                              ]}
                            >
                              <Input
                                placeholder="变量说明：姓名"
                                disabled={
                                  TemplateManageStore.addOrUpdateForm
                                    .templateStatus === 2 ||
                                  TemplateManageStore.addOrUpdateForm
                                    .templateStatus === 4
                                    ? true
                                    : false
                                }
                              />
                            </Form.Item>
                            {TemplateManageStore.addOrUpdateForm
                              .templateStatus !== 2 &&
                              TemplateManageStore.addOrUpdateForm
                                .templateStatus !== 4 && (
                                <MinusCircleOutlined
                                  onClick={() => remove(name)}
                                />
                              )}
                          </Space>
                        ))}
                        {TemplateManageStore.addOrUpdateForm.templateStatus !==
                          2 &&
                          TemplateManageStore.addOrUpdateForm.templateStatus !==
                            4 && (
                            <Form.Item>
                              <Button
                                type="dashed"
                                onClick={() => add()}
                                block
                                icon={<PlusOutlined />}
                              >
                                添加变量说明
                              </Button>
                            </Form.Item>
                          )}
                      </>
                    )}
                  </Form.List>
                </Form.Item>
                <div
                  style={{
                    width: "80%",
                    marginLeft: "100px",
                    color: "rgb(150,150,150)",
                    marginBottom: "20px",
                  }}
                >
                  {
                    "举例: 若您的模板内容为:您的理赔专员{p0}给您致电沟通理赔事宜。则变量名请填p0,变量说明请填姓名。多个变量请逐行填写。"
                  }
                </div>
              </Col>
            )}
            {TemplateManageStore.addOrUpdateForm.isTemplateParamInfo && (
              <Col span={23}>
                <Form.Item
                  label={
                    <div>
                      <div>变量承诺书</div>
                      {TemplateManageStore.addOrUpdateForm.templateStatus !==
                        2 &&
                        TemplateManageStore.addOrUpdateForm.templateStatus !==
                          4 && (
                          <a
                            href={require("../../../assets/template/templateParamFileName.docx")}
                            download={"变量承诺函模版"}
                          >
                            <VerticalAlignBottomOutlined />
                            <span>下载模板</span>
                          </a>
                        )}
                    </div>
                  }
                  name="templateParamFileName"
                  rules={[{ required: true, message: "上传变量承诺书图片" }]}
                  style={{ width: "50%" }}
                >
                  <div>
                    <Upload
                      disabled={
                        TemplateManageStore.addOrUpdateForm.templateStatus ===
                          2 ||
                        TemplateManageStore.addOrUpdateForm.templateStatus === 4
                          ? true
                          : false
                      }
                      action={""}
                      listType="picture-card"
                      fileList={templateParamUploadImgStore.fileList}
                      onPreview={handlePreview}
                      onChange={(e) =>
                        handleUploadFileChange(
                          e,
                          templateParamUploadImgStore,
                          "templateParamFileName"
                        )
                      }
                      beforeUpload={beforeUpload}
                    >
                      {/* {uploadButton} */}
                      {templateParamUploadImgStore.fileList.length >= 1
                        ? null
                        : uploadButton}
                    </Upload>
                    {previewImage && (
                      <Image
                        wrapperStyle={{ display: "none" }}
                        preview={{
                          visible: previewOpen,
                          onVisibleChange: (visible) => setPreviewOpen(visible),
                          afterOpenChange: (visible) =>
                            !visible && setPreviewImage(""),
                        }}
                        src={previewImage}
                      />
                    )}
                  </div>
                </Form.Item>
              </Col>
            )}
            <Col span={23}>
              <div style={{ display: "flex" }}>
                {!TemplateManageStore.isWriteTemplateSignature && (
                  <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
                    <Form.Item
                      label="模版签名"
                      name="templateSignatureNo"
                      rules={[{ required: true, message: "请选择模版签名" }]}
                      style={{ width: "80%", marginRight: "20px" }}
                    >
                      <Select
                        allowClear={true}
                        placeholder="请选择模版签名"
                        showSearch
                        optionFilterProp="label"
                        options={
                          TemplateManageStore.getAllEnumList &&
                          TemplateManageStore.getAllEnumList.map(
                            (item: any) => ({
                              value: item.no,
                              label: item.templateSignature,
                            })
                          )
                        }
                        disabled={
                          TemplateManageStore.addOrUpdateForm.templateStatus ===
                            2 ||
                          TemplateManageStore.addOrUpdateForm.templateStatus ===
                            4
                            ? true
                            : false
                        }
                      ></Select>
                    </Form.Item>
                  </ConfigProvider>
                )}
                {TemplateManageStore.isWriteTemplateSignature && (
                  <Form.Item
                    label="填写模版签名"
                    name="templateSignature"
                    rules={[{ required: true, message: "请输入模版签名" }]}
                    style={{ width: "80%", marginRight: "20px" }}
                  >
                    <Input placeholder="请输入模版签名" />
                  </Form.Item>
                )}
                {TemplateManageStore.addOrUpdateForm.templateStatus !== 2 &&
                  TemplateManageStore.addOrUpdateForm.templateStatus !== 4 && (
                    <Button
                      type="primary"
                      onClick={() => {
                        controlTemplateSignature();
                      }}
                    >
                      {TemplateManageStore.isWriteTemplateSignature
                        ? "去选择模版签名"
                        : "去填写模版签名"}
                    </Button>
                  )}
              </div>
            </Col>
            {/* {TemplateManageStore.addOrUpdateForm.templateSignatureNo === "default" && (
                <Form.Item
                  label="填写模版签名"
                  name="templateSignature"
                  rules={[{ required: true, message: "请输入模版签名" }]}
                  style={{ width: "80%", marginRight: "20px" }}
                >
                  <Input placeholder="请输入模版签名" />
                </Form.Item>
              )} */}
            {TemplateManageStore.addOrUpdateForm.templateSignatureNo &&
              !TemplateManageStore.isWriteTemplateSignature && (
                <Col span={23}>
                  <Form.Item label="统一社会信用代码证书">
                    {TemplateManageStore.socialCreditCertificateObjectNamesUrl
                      ? TemplateManageStore.socialCreditCertificateObjectNamesUrl.map(
                          (item: any, index: any) => {
                            return (
                              <Image
                                key={index}
                                height={200}
                                src={item.url}
                                style={{ paddingRight: "30px" }}
                              />
                            );
                          }
                        )
                      : ""}
                  </Form.Item>
                </Col>
              )}
            {TemplateManageStore.addOrUpdateForm.templateSignatureNo &&
              !TemplateManageStore.isWriteTemplateSignature && (
                <Col span={23}>
                  <Form.Item label="隐私号订购凭证">
                    {TemplateManageStore.orderVoucherObjectNamesUrl
                      ? TemplateManageStore.orderVoucherObjectNamesUrl.map(
                          (item: any, index: any) => {
                            return (
                              <Image
                                key={index}
                                height={200}
                                src={item.url}
                                style={{ paddingRight: "30px" }}
                              />
                            );
                          }
                        )
                      : ""}
                  </Form.Item>
                </Col>
              )}
            {TemplateManageStore.addOrUpdateForm.templateSignatureNo &&
              !TemplateManageStore.isWriteTemplateSignature && (
                <Col span={23}>
                  <Form.Item label="签名授权凭证">
                    {TemplateManageStore.signAuthzCertificateObjectNamesUrl
                      ? TemplateManageStore.signAuthzCertificateObjectNamesUrl.map(
                          (item: any, index: any) => {
                            return (
                              <Image
                                key={index}
                                height={200}
                                src={item.url}
                                style={{ paddingRight: "30px" }}
                              />
                            );
                          }
                        )
                      : ""}
                  </Form.Item>
                </Col>
              )}
            {TemplateManageStore.isWriteTemplateSignature &&
              TemplateManageStore.addOrUpdateForm.templateSignature && (
                <Col span={21}>
                  <Form.Item
                    label="统一社会信用代码证书"
                    name="socialCreditCertificateObjectNames"
                    rules={[
                      {
                        required: true,
                        message: "上传统一社会信用代码证书图片",
                      },
                    ]}
                  >
                    <div>
                      <Upload
                        action={""}
                        listType="picture-card"
                        fileList={
                          socialCreditCertificateObjectNamesUploadImgStore.fileList
                        }
                        onPreview={handlePreview}
                        onChange={(e) =>
                          handleUploadFileChange(
                            e,
                            socialCreditCertificateObjectNamesUploadImgStore,
                            "socialCreditCertificateObjectNames"
                          )
                        }
                        beforeUpload={beforeUpload}
                      >
                        {uploadButton}
                      </Upload>
                      {previewImage && (
                        <Image
                          wrapperStyle={{ display: "none" }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )}
                    </div>
                  </Form.Item>
                </Col>
              )}
            {TemplateManageStore.isWriteTemplateSignature &&
              TemplateManageStore.addOrUpdateForm.templateSignature && (
                <Col span={21}>
                  <Form.Item
                    label="隐私号订购凭证"
                    name="orderVoucherObjectNames"
                    rules={[
                      { required: true, message: "上传隐私号订购凭证图片" },
                    ]}
                  >
                    <div>
                      <Upload
                        action={""}
                        listType="picture-card"
                        fileList={
                          orderVoucherObjectNamesUploadImgStore.fileList
                        }
                        onPreview={handlePreview}
                        onChange={(e) =>
                          handleUploadFileChange(
                            e,
                            orderVoucherObjectNamesUploadImgStore,
                            "orderVoucherObjectNames"
                          )
                        }
                        beforeUpload={beforeUpload}
                      >
                        {uploadButton}
                      </Upload>
                      {previewImage && (
                        <Image
                          wrapperStyle={{ display: "none" }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )}
                    </div>
                  </Form.Item>
                </Col>
              )}
            {TemplateManageStore.isWriteTemplateSignature &&
              TemplateManageStore.addOrUpdateForm.templateSignature && (
                <Col span={21}>
                  <Form.Item
                    label={
                      <div>
                        <div>签名授权凭证</div>
                        {TemplateManageStore.addOrUpdateForm.templateStatus !==
                          2 &&
                          TemplateManageStore.addOrUpdateForm.templateStatus !==
                            4 && (
                            <a
                              href={require("../../../assets/template/signAuthzCertificateObjectNames.docx")}
                              download={"签名授权凭证模版"}
                            >
                              <VerticalAlignBottomOutlined />
                              <span>下载模板</span>
                            </a>
                          )}
                      </div>
                    }
                    name="signAuthzCertificateObjectNames"
                  >
                    <div>
                      <Upload
                        action={""}
                        listType="picture-card"
                        fileList={
                          signAuthzCertificateObjectNamesUploadImgStore.fileList
                        }
                        onPreview={handlePreview}
                        onChange={(e) =>
                          handleUploadFileChange(
                            e,
                            signAuthzCertificateObjectNamesUploadImgStore,
                            "signAuthzCertificateObjectNames"
                          )
                        }
                        beforeUpload={beforeUpload}
                      >
                        {uploadButton}
                      </Upload>
                      {previewImage && (
                        <Image
                          wrapperStyle={{ display: "none" }}
                          preview={{
                            visible: previewOpen,
                            onVisibleChange: (visible) =>
                              setPreviewOpen(visible),
                            afterOpenChange: (visible) =>
                              !visible && setPreviewImage(""),
                          }}
                          src={previewImage}
                        />
                      )}
                    </div>
                  </Form.Item>
                </Col>
              )}
            <Col span={23}>
              <Form.Item label="模版备注" name="templateName">
                <Input
                  placeholder="请输入模版备注"
                  maxLength={10}
                  showCount
                ></Input>
              </Form.Item>
            </Col>
            <Col span={23}>
              <Form.Item label="模版样例" name="templateDemo">
                {/* 【
                {TemplateManageStore.addOrUpdateForm.templateSignatureNo
                  ? TemplateManageStore.getAllEnumList.find(
                      (item: any) =>
                        item.no ===
                        TemplateManageStore.addOrUpdateForm.templateSignatureNo
                    )?.templateSignature
                  : (TemplateManageStore.addOrUpdateForm.templateSignature?TemplateManageStore.addOrUpdateForm.templateSignature:"xxx")}
                】
                {TemplateManageStore.addOrUpdateForm.templateInfo
                  ? TemplateManageStore.addOrUpdateForm.templateInfo
                  : "xxxxxxxxxx"} */}
                {TemplateManageStore.addOrUpdateForm.templateDemo}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={23} offset={18}>
              <Space style={{ marginTop: "20px" }}>
                <Button htmlType="reset" onClick={() => closeModal()}>
                  取消
                </Button>
                <Button type="primary" htmlType="submit">
                  确定
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Fragment>
  );
}

export default observer(Add);
